import React, { Component } from 'react';
import moment from 'moment';
import IgniteDataTable from '../../../common/datatable';
import ArrowButton from '../../../common/button-arrow';
import { history } from '../../../../store';

const formatDate = data => (data ? moment(data).format('DD/MM/YYYY') : '-');

const formatList = data => (data && data.length ? data.join(', ') : '-');

class QrCodeCampaignsList extends Component {
  render() {
    const actions = [
      (index, row) => (
        <ArrowButton
          arrow={false}
          submit={false}
          color="red"
          onClick={() => history.push(`/admin/qr_code_campaigns/${row.id}`)}
        >
          {row.attributes.editable ? 'Edit' : 'View'}
        </ArrowButton>
      )
    ];

    const columns = [
      {
        prop: 'campaign-unique-id',
        title: 'Campaign ID'
      },
      {
        prop: 'abm-codes',
        title: 'ABM code',
        format: formatList
      },
      {
        prop: 'campaign-type',
        title: 'Type'
      },
      {
        prop: 'start-date',
        title: 'Start date',
        format: formatDate
      },
      {
        prop: 'end-date',
        title: 'End date',
        format: formatDate
      },
      {
        prop: 'groups-count',
        title: 'Groups'
      }
    ];

    return (
      <IgniteDataTable
        actions={actions}
        columns={columns}
        data={this.props.campaigns}
        hideId={false}
      />
    );
  }
}

export default QrCodeCampaignsList;
